import * as actionTypes from './../actions/birthDateAction';
import * as moment from 'moment';

const initialState = {
  selected: null,
  months: null,
  years: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
  visible: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      return {
        ...state,
        selected: action.selected,
      };
    case actionTypes.SET_YEAR:
      return {
        ...state,
        years: action.years,
      };
    case actionTypes.SET_MONTH:
      return {
        ...state,
        months: action.months,
      };
    case actionTypes.SET_DATE:
      return {
        ...state,
        selected: action.selected,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: initialState.selected,
        years: initialState.years,
        months: initialState.months,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case actionTypes.TOGGLE_VISIBILITY:
      return {
        ...state,
        visible: action.isFocussed,
      };

    case actionTypes.HIDE:
      return {
        ...state,
        visible: false,
      };

    case actionTypes.SHOW:
      return {
        ...state,
        visible: true,
      };

    default:
      return state;
  }
};

export default reducer;
